import { render } from "./detail-info-group.vue?vue&type=template&id=d2dca67c"
import script from "./detail-info-group.vue?vue&type=script&lang=js"
export * from "./detail-info-group.vue?vue&type=script&lang=js"

import "./detail-info-group.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/feng.chen/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__